export default [
  {
    name: 'Проекты',
    link: '/projects/'
  },
  {
    name: 'Услуги',
    type: 'services',
    children: [
      { name: 'Стратегия', link: '/strategy/', desc: 'Выбираем путь и создаем основу' },
      {
        name: 'Брендинг',
        link: '/brands/',
        desc: 'От идеи до коммуникации',
        subMenu: [
          { name: 'Фирменный стиль', link: '/corporate-identity/' },
          { name: 'Дизайн-поддержка', link: '/design-support/' },
          { name: 'Брендинг работодателя', link: '/employer-branding/' },
          { name: 'Брендинг для ИТ', link: '/it-branding/' },
          { name: 'Бренд-платформа', link: '/brand-platform/' },
          { name: 'Нейминг', link: '/naming/' }
        ]
      },
      {
        name: 'Дизайн интерфейсов (UX/UI)',
        link: '/ux-ui/',
        desc: 'Осмысленный и эстетичный',
        subMenu: [
          { name: 'Исследования и проектирование интерфейсов', link: '/ux-research/' },
          { name: 'Аудит сайта (UX-аудит)', link: '/ux-audit/' },
          // { name: 'Дизайн интерфейсов сайтов и продуктов', link: '/' },
          { name: 'Дизайн-команды', link: '/design-team/' },
          {
            name: 'Сайты на решениях без программирования (Nocode)',
            link: 'https://no-code.nimax.ru/',
            id: 'no-code-sites'
          }
        ]
      },
      {
        name: 'Веб-разработка',
        link: '/soft/',
        desc: 'Полный цикл разработки',
        subMenu: [
          { name: 'Корпоративные сайты', link: '/corp/' },
          { name: 'Разработка сайтов и сервисов', link: '/web-services/' },
          { name: 'Техническая поддержка', link: '/support/' },
          // { name: 'Разработка мобильных приложений', link: '/' },
          // { name: 'Технологический аудит', link: '/' },
          // { name: 'DevOps-сопровождение', link: '/' },
          { name: 'Боты: Telegram / Slack', link: '/chat-bots/' }
          // { name: 'Адаптивная вёрстка', link: '/strategy/' },
        ]
      },
      {
        name: 'Перформанс-маркетинг',
        link: '/performance/',
        desc: 'Вдумчивый и эффективный',
        subMenu: [
          // { name: 'Growth-маркетинг', link: '/' },
          { name: 'Международное привлечение клиентов (Global лидогенерация)', link: '/global-lead-generation/' },
          { name: 'Продвижение в поиске (SEO)', link: '/seo/' },
          { name: 'Продвижение мобильных приложений (ASO)', link: '/aso/' },
          { name: 'Контекстная реклама', link: '/context/' },
          { name: 'Таргетированная реклама', link: '/target/' }
          // { name: 'Диджитал-стратегия', link: '/' },
          // { name: 'Медийная и programmatic-реклама', link: '/' },
          // { name: 'Веб-аналитика', link: '/dashboards/' },
        ]
      },
      {
        name: 'Коммуникация',
        link: '/media/',
        desc: 'От СММ до креативных кампаний',
        subMenu: [
          { name: 'Работа с блогерами (инфлюенс-маркетинг)', link: '/influence/' },
          { name: 'СММ-продвижение', link: '/smm/' },
          { name: 'Контент', link: '/content/' }
        ]
      }
      // {
      //   name: 'Образование',
      //   link: 'http://nimax.school/?utm_source=main_page&utm_medium=banner&utm_campaign=up_menu_btn'
      // }
    ]
  },
  // {
  //   name: 'Отрасли',
  //   type: 'industry',
  //   children: [
  //     // { name: 'ИТ', link: '/it/' },
  //     // { name: 'Финтех', link: '/fintech/' },
  //     { name: 'ESG', link: '/esg/' }
  //   ]
  // },
  {
    name: 'Компания',
    type: 'company',
    children: [
      { name: 'О компании', link: '/company/' },
      { name: 'Постеры', link: '/posters/' },
      { name: 'Тесты, спецпроекты', link: '/spec/' },
      { name: 'Статьи', link: '/articles/' }
    ]
  },
  // {
  //   name: 'Курсы',
  //   link: 'https://school.nimax.ru'
  // },
  {
    name: 'Вакансии',
    link: 'https://hr.nimax.ru'
  },
  // {
  //   name: 'Школа',
  //   link: 'https://nimax.school/'
  // },
  {
    name: 'Контакты',
    link: '/contacts/'
  }
];
